import { PatternBg } from '../images';
import { useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';

const Newsletter = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle newsletter subscription
    console.log('Subscribed with:', email);
    setEmail('');
  };

  return (
    <section 
      className="newsletter bg-light" 
      style={{ background:`url(${PatternBg}) no-repeat` }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={8} className="py-5 my-5">
            <div className="subscribe-header text-center pb-3">
              <h3 className="section-title text-uppercase">Sign Up for our newsletter</h3>
            </div>
            <Form onSubmit={handleSubmit} className="d-flex flex-wrap gap-2">
              <Form.Control
                type="email"
                placeholder="Your Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <Button type="submit" variant="dark" className="text-uppercase w-100">
                Subscribe
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Newsletter;